import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { ITextEmailButtonFormProps } from '../components/form/text-email-button-form/text-email-button-form';
import { IButtonProps } from '../components/button/button';
import { ButtonModel } from './button-model';
import { IInputProps } from '../components/form/components/input/input';
import { InputTextModel } from './input-text-model';
import { ICheckboxProps } from '../components/form/components/checkbox/checkbox';
import { CheckboxModel } from './checkbox-model';

export class TextEmailButtonFormModel extends ContentItem {
  get inputText(): IInputProps[] {
    const getInputText = get(this._config, 'elements.input_email.value', null);

    const transformInputText = getInputText
      ? getInputText.map((input: IInputText) => InputTextModel.create(input))
      : null;

    return transformInputText;
  }

  get postUrl(): string {
    return get(this._config, 'elements.post_url.value', '');
  }

  get lineUnderText(): boolean {
    return (
      get(this._config, 'elements.line_under_text.value[0].codename', '') ===
      'true'
    );
  }

  get text(): string {
    return get(this._config, 'elements.text_value.value', '');
  }

  get successMessage(): string {
    return get(this._config, 'elements.success_message.value', '');
  }

  get submitButton(): IButtonProps[] {
    const getSubmitButton = get(this._config, 'elements.button.value', null);

    const transformSubmitButton = getSubmitButton
      ? getSubmitButton.map((button: IButton) => ButtonModel.create(button))
      : null;

    return transformSubmitButton;
  }

  get checkboxes(): ICheckboxProps[] {
    const getCheckbox = get(this._config, 'elements.checkbox.value', null);

    const transformCheckbox = getCheckbox
      ? getCheckbox.map((checkbox: ICheckbox) => CheckboxModel.create(checkbox))
      : null;

    return transformCheckbox;
  }

  public static create(data: ITextEmailButtonForm): ITextEmailButtonFormProps {
    const {
      inputText,
      postUrl,
      submitButton,
      text,
      lineUnderText,
      successMessage,
      checkboxes
    } = new TextEmailButtonFormModel(data);
    return {
      inputText,
      postUrl,
      submitButton,
      text,
      lineUnderText,
      successMessage,
      checkboxes
    };
  }
}
